import { consumables } from "./consumableTypes";
import { furniture } from "./furnitureTypes";
import { ItemBreed } from "./Item";

export const items = {
  ...furniture,
  ...consumables,
} as const;

export const ItemTypes = Object.entries(items).reduce((r, [key, value]) => {
  r[key as keyof typeof items] = new ItemBreed(key, value);
  return r;
}, {} as Record<keyof typeof items, ItemBreed>);
